






import Vue from 'vue';
export default Vue.extend({
  name: 'StepNumber',
  props: {
    stepNumber: {
      type: Number,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/StepNumber.vue